import { Col, Collapse, Row, Typography } from "antd";
import { Spacer } from "../common/Spacer";
import { useCurrentBreakpointName } from "react-socks";
import Header from "../../mobile/components/Header";
import React from "react";
import Styled from "styled-components";

const { Panel } = Collapse;
const { Title } = Typography;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

export const FAQComponent = ({ history }) => {
	const breakpoint = useCurrentBreakpointName();

	if (breakpoint === "mobile") {
		return (
			<>
				<Header goBack={() => history.push("/home")}></Header>

				<FAQContainer>
					<Row>
						<Spacer rows={2} />

						<Col>
							<Title style={{ color: "#274AA8" }} level={2}>
								Preguntas Frecuentes
							</Title>
						</Col>
						<Spacer rows={2} />
					</Row>
					<Row>
						<Title style={{ marginLeft: 10 }} level={3}>
							Notificaciones
						</Title>
						<Col>
							<CollpaseNotification />
						</Col>
						<Spacer rows={1} />
						<Title style={{ marginLeft: 10 }} level={3}>
							Ingreso
						</Title>
						<Col>
							<CollapseIngreso />
						</Col>
						<Spacer rows={1} />
						<Title style={{ marginLeft: 10 }} level={3}>
							Tickets Virtuales
						</Title>
						<Col>
							<CollapseTickets />
						</Col>
						<Spacer rows={1} />
						<Title style={{ marginLeft: 10 }} level={3}>
							Reservar Hora
						</Title>
						<Col>
							<CollapseReservas />
						</Col>
						<Spacer rows={1} />
						<Title style={{ marginLeft: 10 }} level={3}>
							Código QR de ticket físico
						</Title>
						<Col>
							<CollapseQR />
						</Col>
						<Spacer rows={2} />
					</Row>
				</FAQContainer>
			</>
		);
	}
	return (
		<FAQContainer>
			<Row>
				<Spacer rows={2} />
				<Col>
					<Title style={{ color: "#274AA8" }} level={2}>
						Preguntas Frecuentes
					</Title>
				</Col>
				<Spacer rows={2} />
			</Row>
			<Row style={{ flexDirection: "column" }}>
				<Title level={3}>Notificaciones</Title>
				<Col style={{ maxWidth: 800, minWidth: 800 }}>
					<CollpaseNotification />
				</Col>
				<Spacer rows={1} />
				<Title level={3}>Ingreso</Title>
				<Col style={{ maxWidth: 800, minWidth: 800 }}>
					<CollapseIngreso />
				</Col>
				<Spacer rows={1} />
				<Title level={3}>Tickets Virtuales</Title>
				<Col style={{ maxWidth: 800, minWidth: 800 }}>
					<CollapseTickets />
				</Col>
				<Spacer rows={1} />
				<Title level={3}>Reservar Hora</Title>
				<Col style={{ maxWidth: 800, minWidth: 800 }}>
					<CollapseReservas />
				</Col>
				<Spacer rows={1} />
				<Title level={3}>Código QR de ticket físico</Title>
				<Col style={{ maxWidth: 800, minWidth: 800 }}>
					<CollapseQR />
				</Col>
			</Row>
		</FAQContainer>
	);
};

const CollpaseNotification = () => (
	<CollapseStyled defaultActiveKey={["1"]}>
		<Panel
			header={
				<HeaderCollapse
					label={
						"¿Qué hago si no me llegan las notificaciones al tomar un ticket virtual? "
					}
				/>
			}
			key="1"
		>
			<p>
				Por el momento, estas se encuentran
				<strong> disponibles para dispositivos Android</strong> con
				navegadores como Chrome, Firefox y Edge.
			</p>
			<p>
				Las puedes activar en tu navegador chrome siguiendo estos pasos:
			</p>
			<ol>
				<li>
					Desde un teléfono o tablet Android abre la app de Chrome.
				</li>
				<li>
					A la derecha de la barra de direcciones, presiona
					{""} <strong>Más</strong> y luego{" "}
					<strong>Configuración.</strong>
				</li>
				<li>
					Busca en el menú la opción <strong>Notificaciones</strong> e
					ingresa.
				</li>
				<li>
					En la parte superior, activa la opción de mostrar
					notificaciones (show notifications).
				</li>
				<li>
					Encuentra más abajo en el mismo listado la opción de sitios,
					activa las notificaciones como el paso anterior y asegúrate
					de tener marcado el sitio zeroq.cl
				</li>
				<li>
					Asegurate de tener las notificaciones activadas en tu perfil
					de Zero Q.
				</li>
			</ol>
			<p>
				Te dejamos un <strong>video </strong> tutorial para activar las
				notificaciones en Chrome:
			</p>
			<div
				style={{
					width: "100%",
					display: "flex",
					justifyContent: "center",
				}}
			>
				<iframe
					width="100%"
					height="315"
					src="https://www.youtube.com/embed/ubD-lv0qYWg"
					title="YouTube video player"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>
			</div>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="Quiero activar/desactivar las notificaciones de ZeroQ" />
			}
			key="2"
		>
			<p>
				Ingresa en la web de Zero Q a tu perfil, ubicado en el Menú
				horizontal inferior, al final econtrarás la opción de activar o
				desactivar la opción de notificaciones.
			</p>
		</Panel>
	</CollapseStyled>
);
const CollapseIngreso = () => (
	<CollapseStyled>
		<Panel
			header={
				<HeaderCollapse label={"¿Qué pasa si olvidé mi contraseña?"} />
			}
			key="1"
		>
			<p>
				Podrás restaurarla desde Zero.cl. Al iniciar sesión, selecciona
				la opción {"Recuperar contraseña"}. El sistema te enviará un
				correo al email ingresado, con un link de restablecimiento de
				contraseña. Si este correo no llega, te recomessndamos revisar
				la sección spam o correo no deseado de tu mail.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Qué hago cuando llegue a la sucursal?" />
			}
			key="2"
		>
			<p>
				Debes mostrar tu ticket desde tu equipo móvil al momento de ser
				llamado por el módulo.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="No puedo entrar a una sucursal en la web" />
			}
			key="3"
		>
			<p>
				Si la sucursal es mostrada (traslucida), es porque la oficina
				deshabilitó su acceso temporalmente. Te sugerimos revisar si ese
				empresa cuenta con más sucursales con ZeroQ cercanas a ti.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Los ticket virtuales y reservas son mostrados en los TV de las sucursales?" />
			}
			key="4"
		>
			<p>
				Si, cuando el ticket físico, ticket virtual y reservas son
				llamados en la sucursal son mostrados en el Display (TV) para
				que puedas identificar a qué módulo dirigirte.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="Me di de baja de los correos recibidos por ZeroQ  y quiero volver a recibirlos" />
			}
			key="5"
		>
			<p>ZeroQ solo envía notificación de correo cuando:</p>
			<ul>
				<li>La Reserva es Confirmada</li>
				<li>Recordatorio de Reserva</li>
				<li>La Reserva es Cancelada</li>
			</ul>
			<p>
				Encuesta de atención Para desbloquear tu email, envíanos un
				correo a <strong>usuarios@zeroq.cl</strong>
			</p>
		</Panel>
	</CollapseStyled>
);
const CollapseReservas = () => (
	<CollapseStyled>
		<Panel header={<HeaderCollapse label="¿Cómo reservar hora?" />} key="1">
			<p>
				Si lo que quieres es planificar tu visita, con ZeroQ puedes
				hacerlo.
			</p>
			<p>
				Una vez que ya hayas seleccionado la sucursal de tu preferencia
				y selecciones la fila para el trámite que necesitas realizar,
				podrás apretar el botón {"Reserva"}.
			</p>
			<p>
				Las reservas son mostradas en bloques de 15 minutos, divididos
				en turnos de mañana y tarde. Los usuarios podrán tomar una
				reserva por fila y por bloque horario; esto quiere decir que,
				hasta que la reserva no sea atendida, el usuario no podrá tomar
				más reservas en esa fila.
			</p>
			<p>
				Para las reservas recomendamos llegar al menos 5 minutos antes
				del agendamiento.
			</p>
			<p>
				Recuerda mostrar tu reserva desde tu equipo móvil al momento de
				ser llamado por el módulo.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿En la Web dónde veo mis Reservas?" />
			}
			key="2"
		>
			<p>
				Desde un computador, en la barra en la parte superior de la
				pantalla se encuentra la sección reservas, desde un celular lo
				encuentras en el menú horizontal inferior, ahí podrás ver las
				reservas que tengas pendiente por ser atendidas. Una vez que las
				reservas son llamadas se mueven a la bandeja de historial.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Si ya saque una reserva tengo que sacar un ticket cuando llegue a la sucursal?" />
			}
			key="3"
		>
			<p>
				No, no es necesario. Tu ticket virtual o reserva ya asegura tu
				atención.
			</p>
		</Panel>
		<Panel
			header={<HeaderCollapse label="Quiero cancelar mi reserva" />}
			key="4"
		>
			<p>
				Ingresa en la web de Zero Q, entra a la sección de reservas
				desde el menú horizontal, haz click en la reserva y presiona el
				botón Cancelar
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Puedo descargar mi comprobante de reserva?" />
			}
			key="5"
		>
			<p>
				Si, puedes descargarlo en formato PDF para mostrarlo en la
				sucursal o en caso de no disponer de datos móviles.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Qué pasa si la sucursal a la cual quiero acudir no tiene disponible reserva de hora?" />
			}
			key="6"
		>
			<p>
				Algunas sucursales no tienen activada esta opción. En ese caso
				solo podrás tomar un ticket virtual, por lo que te recomendamos
				tomarlo el mismo día que quieras asistir.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Si tomé una reserva y no la encuentro en la web?" />
			}
			key="7"
		>
			<p>
				Si tomaste una reserva, y no está en la sección de Tickets /
				Reservas, es porque no fue generada de manera efectiva, esto
				ocurre cuando la oficina tiene intermitencia de conexión.
			</p>
			<p>
				De no encontrar la reserva en ninguna de está secciones, revisa
				que hayas recibido un correo electrónico de confirmación de
				reserva o contacta a nuestro equipo de soporte para revisar en
				la data si la reserva se generó de manera correcta.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Si tomé una reserva en una sucursal me pueden atender con ese mismo número en otra sucursal?" />
			}
			key="8"
		>
			<p>
				No, porque cada sucursal tiene su base de datos segmentada, por
				lo que la reserva será llamada por el módulo en la sucursal
				donde fue creada.
			</p>
		</Panel>
	</CollapseStyled>
);
const CollapseQR = () => (
	<CollapseStyled>
		<Panel
			header={
				<HeaderCollapse label="¿Cómo se usa el código QR de mi ticket físico?" />
			}
			key="1"
		>
			<ol>
				<li>Toma un ticket físico en la sucursal</li>
				<li>
					Escanea con tu móvil el código QR mostrado en el ticket
					(puedes escanearlo desde la cámara de tu celular o con
					alguna aplicación que lea estos códigos)
				</li>
				<li>Haz click en el enlace</li>
				<li>
					Este te redirige a una página web donde podrás hacer el
					seguimiento de tu ticket
				</li>
			</ol>
		</Panel>
	</CollapseStyled>
);
const CollapseTickets = () => (
	<CollapseStyled>
		<Panel
			header={<HeaderCollapse label="¿Cómo sacar un ticket virtual?" />}
			key="1"
		>
			<ol>
				<li>Ingresa a ZeroQ.cl</li>
				<li>Selecciona la sucursal a la cual quieres asistir</li>
				<li>
					Selecciona la fila para el servicio que buscas: verás las
					filas de esa oficina, seleccionas la que compagine con el
					trámite que deseas realizar, mostrándose cuántas personas
					tienes por delante y el tiempo aproximado de espera en esa
					fila.
				</li>
				<li>
					Selecciona ticket virtual: si quieres acudir durante el
					mismo día o bien planifica tu visita reservando hora.
				</li>
				<li>
					Presiona sacar ticket y ya estarás en la fila esperando tu
					atención.
				</li>
				<li>Muestra tu ticket cuando llegues a la sucursal.</li>
			</ol>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿En la web dónde veo mis tickets?" />
			}
			key="2"
		>
			<p>
				Desde un computador, en la barra en la parte superior de la
				pantalla se encuentra la sección tickets, desde un celular lo
				encuentras en el menú horizontal inferior, ahí podrás ver los
				tickets virtuales o reservas que tengas pendiente por ser
				atendidos. Una vez que los tickets/Reservas son llamados se
				mueven a la bandeja de Historial.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="No puedo entrar a una sucursal en la web" />
			}
			key="3"
		>
			<p>
				Si la sucursal es mostrada (traslucida), es porque la oficina
				deshabilitó su acceso temporalmente. Te sugerimos revisar si ese
				empresa cuenta con más sucursales con ZeroQ cercanas a ti.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Tengo que sacar un ticket cuando llegue a la sucursal?" />
			}
			key="4"
		>
			<p>
				No, no es necesario. Tu ticket virtual o reserva ya asegura tu
				atención.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Qué pasa si llegue a la sucursal pero ya pasó mi numero?" />
			}
			key="5"
		>
			<p>
				Lamentablemente eso significa que perdiste tu turno de atención.
				En ese caso deberás volver a tomar un ticket de atención ya sea
				virtual por la web o de forma presencial.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Cuál es la diferencia entre el ticket virtual y la reserva de hora?" />
			}
			key="6"
		>
			<p>
				El ticket virtual es para realizar un trámite durante el mismo
				día, mientras que la reserva de hora es para programar tu
				atención para un día y hora específico.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Qué significan los minutos de espera que aparecen antes de tomar el ticket?" />
			}
			key="7"
		>
			<p>Es el tiempo estimado que pasará antes de que sea tu turno</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Con cuanta anticipación debo tomar un ticket virtual?" />
			}
			key="8"
		>
			<p>
				Debes fijarte en las personas en la fila y minutos de espera que
				se muestran para el trámite. Cuando estos son bajos,
				recomendamos sacar un ticket virtual cuando se esté cerca de la
				oficina.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Puedo descargar mi comprobante de ticket virtual?" />
			}
			key="9"
		>
			<p>
				Si, puedes descargarlo en formato PDF para mostrarlo en la
				sucursal o en caso de no disponer de datos móviles.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Porqué el sistema me restringe la toma de ticket?" />
			}
			key="10"
		>
			<p>
				Si la oficina en donde tienes un ticket activo tiene restricción
				activada solo podrás tener un ticket por ser atendido en esa
				oficina o en ese trámite, una vez ese ticket sea llamado podrás
				tomar otro.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Por qué algunos trámites aparecen en color azul y no me permite tomar ticket virtual?" />
			}
			key="11"
		>
			<p>
				Porque la fila o trámite ha sido cerrado por la sucursal
				impidiendo la toma de tickets físicos y virtuales. Esta acción
				se da cuando:
			</p>
			<ol>
				<li>La sucursal se encuentra cerrada</li>
				<li>
					Cuando ese trámite ha superado el límite de tickets
					configurado por la oficina.
				</li>
				<li>
					La oficina ha superado el aforo y cierran la fila por
					contingencia.
				</li>
			</ol>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Porque un trámite dice fila deshabilitada cuando intento tomar un ticket virtual?" />
			}
			key="12"
		>
			<p>
				Porque la oficina ha desactivado la opción de ticket virtual en
				toda la sucursal o en ese trámite.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Si tome un ticket y no lo encuentro en la web?" />
			}
			key="13"
		>
			<p>
				Si tomaste un ticket, y no está en la sección tickets / activos,
				es porqué este ticket ya fue llamado por un módulo y lo verás
				reflejado en Tickets / Historial.
			</p>
			<p>
				De no encontrar el ticket en ninguna de está secciones contacta
				a nuestro equipo de soporte para revisar en la data si el ticket
				se generó de manera correcta.
			</p>
		</Panel>
		<Panel
			header={
				<HeaderCollapse label="¿Si tomé un ticket en una sucursal me pueden atender con ese mismo número en otra sucursal?" />
			}
			key="14"
		>
			<p>
				No, porque cada sucursal tiene su base de datos segmentada, por
				lo que el ticket será llamado por el módulo en la sucursal donde
				fue creado.
			</p>
		</Panel>
	</CollapseStyled>
);

const HeaderCollapse = ({ label }) => (
	<div className="collapse__container-item-header">{label}</div>
);
const FAQContainer = Styled.div`
    display: flex;
    width: 100%;
    align-items: center; 
    flex-direction: column;
	

	& h3 {
		color: #274aa8;
	}
`;

const CollapseStyled = Styled(Collapse)`

&  .ant-collapse-arrow {
	& svg {
		fill: #274AA8
	}
}

& .collapse__container-item-header {
    color: #274AA8;
    font-weight:700
}

& li {
    margin-top: 12px
}

`;
